export const naturePrimary = {
  50: '#DCEADE',
  100: '#C0D9C2',
  200: '#98C19B',
  300: '#6EA772',
  400: '#448E4A',
  500: '#308236',
  600: '#2B7531',
  700: '#225B26',
  800: '#18411B',
  900: '#0E2710',
  950: '#071209',
};

export const natureSecondary = {
  50: '#EAE5D7',
  100: '#EAE5D7',
  200: '#C7B78D',
  300: '#B0995E',
  400: '#997C30',
  500: '#8E6E1A',
  600: '#806317',
  700: '#644D12',
  800: '#47370D',
  900: '#2B2108',
  950: '#151105',
};

export const natureNeutral = {
  50: '#F0EEE6',
  100: '#E1DFDA',
  200: '#D7D5D0',
  300: '#C8C7C0',
  400: '#AFADA5',
  500: '#8A877E',
  600: '#63615A',
  700: '#3D3B37',
  800: '#2E2D2A',
  900: '#201E1C',
  950: '#131311',
};

export const natureError = {
  50: '#F0D6D6',
  100: '#EBC7C8',
  200: '#DEA3A4',
  300: '#D07E7F',
  400: '#C3595B',
  500: '#BC4749',
  600: '#AA4042',
  700: '#843233',
  800: '#5E2324',
  900: '#391516',
  950: '#160808',
};

export const natureSuccess = {
  50: '#E4EAD7',
  100: '#CDD8B6',
  200: '#ADBE86',
  300: '#8CA455',
  400: '#6B8A25',
  500: '#5B7D0D',
  600: '#52710C',
  700: '#405809',
  800: '#2D3E06',
  900: '#1B2604',
  950: '#101802',
};

export const natureWarning = {
  50: '#EEE0D3',
  100: '#E6CFBA',
  200: '#D5AF8D',
  300: '#C48F5F',
  400: '#B36F31',
  500: '#AB5F1B',
  600: '#9A5618',
  700: '#784313',
  800: '#552F0D',
  900: '#341D08',
  950: '#160D04',
};

export const natureInfo = {
  50: '#D8E3E9',
  100: '#C4D7DD',
  200: '#9EBDC8',
  300: '#76A2B1',
  400: '#4F879B',
  500: '#3C7A90',
  600: '#366E82',
  700: '#2A5665',
  800: '#1E3D48',
  900: '#12252B',
  950: '#070F12',
};
